// @flow
import complot from './complot'
import complotBottle from './complotBottle'
import daura from './daura'
import dauraMarzen from './dauraMarzen'
import estrellaDamm from './estrellaDamm'
import malquerida from './malquerida'
import freeDammCero from './freeDammCero'
import freeDammLimon from './freeDammLimon'
import freeDammTostada from '../specialPacks/freeDammTostada'
import vollDamm from './vollDamm'
import inedit from './inedit'

const type = 'beer'

export default [
  {
    ...estrellaDamm,
    type
  },
  {
    ...complot,
    type
  },
  {
    ...complotBottle,
    type
  },
  {
    ...malquerida,
    type
  },
  {
    ...daura,
    type
  },
  {
    ...dauraMarzen,
    type
  },
  {
    ...freeDammCero,
    type
  },
  {
    ...freeDammLimon,
    type
  },
  {
    ...freeDammTostada,
    type
  },
  {
    ...vollDamm,
    type
  },
  {
    ...inedit,
    type
  }
]
